import React from 'react'
import './burger.css';
import { Link } from 'react-router-dom'

export default function Burgernav() {
  return (
   <>
<nav className='burger' role="navigation">
  <div id="menuToggle">
    {/*
    A fake / hidden checkbox is used as click reciever,
    so you can use the :checked selector on it.
    */}
    <input type="checkbox" id="menuCheckbox" />
    {/*
    Some spans to act as a hamburger.
    
    They are acting like a real hamburger,
    not that McDonalds stuff.
    */}
    <span />
    <span />
    <span />
    {/*
    Too bad the menu has to be inside of the button
    but hey, it's pure CSS magic.
    */}
    <ul id="menu">
      {/* 
We can use a label here to close upon click (when doing same page navigation), this
does require a slight bit of JS.
*/}
      {/* <li>
      <Link to="/">Overview</Link>
      </li> */}
     
      {/* These just close the menu */}
      <li>
      <Link to="/about">About us</Link>
      </li>
      <li>
      <Link to="/membership">Membership</Link>
      </li>
      {/* Or just use regular URLs */}
      <li>
       <Link to="/donation">Donation</Link>
      </li> <li>
      <Link to="/project">Vision & Mission</Link>
      </li>
       {/* <li>
     <Link to="/gallery">Photo Gallery</Link>
      </li> */}
    </ul>
  </div>
</nav>

   </>
  )
}
